import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import store from '@/store'

async function fetchV2PriorBottle(storeId) {
  const token = await store.dispatch('getToken', {
    subdomain: window.location.host
  })

  const res = await fetch(`${process.env.VUE_APP_API_BASE_URL}/merchant/v2/store/${storeId}/prior_bottle`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + token
    }
  })

  if (res.status === 404) {
    console.info('[prior_bottle] No prior bottle exists for this store/customer')
    return null
  }
  if (!res.ok) throw new Error(res.status)

  return res.json()
}

export function usePriorBottleQuery(storeId) {
  const resolvedStoreId = computed(() => (typeof storeId === 'function' ? storeId() : storeId?.value ?? storeId))

  const query = useQuery({
    queryKey: computed(() => ['v2-prior-bottle', resolvedStoreId.value]),
    queryFn: () => fetchV2PriorBottle(resolvedStoreId.value),
    enabled: computed(() => !!resolvedStoreId.value && store.getters.hasV2Checkout),
    staleTime: 0
  })

  const priorBottle = computed(() => query.data.value?.cart ?? null)

  return {
    ...query,
    priorBottle
  }
}
